import { useEffect, useState } from 'react';

export const useIpAndCountry = () => {
  const [ipAddress, setIpAddress] = useState('');
  const [countryCode, setCountryCode] = useState('');

  useEffect(() => {
    const fetchIpAndCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        if (data.ip && data.country) {
          console.log('✅ [IP Detection] Resolved via ipapi.co:', {
            ip: data.ip,
            countryCode: data.country_code,
          });
          setIpAddress(data.ip);
          setCountryCode(data.country_code);
          return;
        }
        console.warn('⚠️ [IP Detection] ipapi.co returned incomplete data, trying fallback 1 (cloudflare):', data);

        const cfResponse = await fetch('https://cloudflare.com/cdn-cgi/trace');
        const cfText = await cfResponse.text();
        if (cfText) {
          const dataObj: Record<string, string> = cfText
            .trim()
            .split('\n')
            .reduce((obj, pair) => {
              const parts = pair.split('=');
              if (parts.length === 2) {
                const [key, value] = parts;
                return { ...obj, [key]: value };
              }
              return obj;
            }, {} as Record<string, string>);

          if (dataObj.ip) {
            console.log('✅ [IP Detection] Resolved via cloudflare trace (fallback 1):', {
              ip: dataObj.ip,
              loc: dataObj.loc,
            });
            setIpAddress(dataObj.ip);
            setCountryCode(dataObj.loc || '');
            return;
          }
          console.warn('⚠️ [IP Detection] cloudflare trace had no ip field, trying fallback 2 (geolocation-db):', dataObj);
        } else {
          console.warn('⚠️ [IP Detection] cloudflare trace returned empty text, trying fallback 2 (geolocation-db)');
        }

        const geoResponse = await fetch('https://geolocation-db.com/json/');
        const geoData = await geoResponse.json();
        if (geoData.IPv4) {
          console.log('✅ [IP Detection] Resolved via geolocation-db.com (fallback 2):', {
            ip: geoData.IPv4,
            countryCode: geoData.country_code,
          });
          setIpAddress(geoData.IPv4);
          setCountryCode(geoData.country_code);
        } else {
          console.error('❌ [IP Detection] All 3 services failed to resolve IP/country. Last response (geolocation-db):', geoData);
        }
      } catch (error) {
        console.error('❌ [IP Detection] Threw an exception before completing — network blocked, CORS, or ad-blocker likely:', error);
      }
    };

    fetchIpAndCountry();
  }, []);

  return { ipAddress, countryCode };
};